module.exports = __webpack_public_path__ + "img/EducationProgramKenya_2.764ea23d.jpg";